import React from 'react';

import styles from './Help.module.scss';
import Icon from '../Icon/Icon';
import Tooltip from '../Tooltip/Tooltip';

function Help({ tooltip }) {
  return (
    <Tooltip tooltip={tooltip} top>
      <Icon icon="question-circle" className={styles.icon} />
    </Tooltip>
  );
}

export default Help;
